export enum PortalLocation {
  VIDEO_VIEW = "VIDEO_VIEW",
  ROOT = "ROOT",
}
